import { getInfo } from "@/api/login";
import { getToken, setToken, removeToken } from "@/utils/auth";
import { getCookie } from "../../utils/support";

const user = {
  state: {
    token: "",
    uid: "",
    roles: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_UID: (state, name) => {
      state.uid = name;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    }
  },

  actions: {
    // 获取用户信息
    GetInfo({ commit, state }) {
      state.uid = getCookie("uid");
      return new Promise((resolve, reject) => {
        getInfo()
          .then(res => {
            if (res.success) {
              // 验证返回的roles是否是一个非空数组
              state.roles.push(state.uid);
            }
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit("SET_TOKEN", "");
        commit("SET_ROLES", []);
        removeToken();
        resolve();
      });
    }
  }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js